const siteUrl = import.meta.env.VITE_SITE_URL || "https://smartwork.fr";
const contactEmail =
	import.meta.env.VITE_LEGAL_CONTACT_EMAIL || "contact@smartwork.fr";
const contactPhone =
	import.meta.env.VITE_LEGAL_CONTACT_PHONE || "+33 2 78 77 67 92";
const publisherName = import.meta.env.VITE_LEGAL_PUBLISHER || "SmartWork";
const publisherStatus =
	import.meta.env.VITE_LEGAL_STATUS || "SASU, société par actions simplifiée unipersonnelle";
const publisherAddress =
	import.meta.env.VITE_LEGAL_ADDRESS ||
	"105 bis Le 105, allée François Mitterrand, 76100 Rouen";
const publisherRegistration =
	import.meta.env.VITE_LEGAL_REGISTRATION ||
	"804 466 738 R.C.S. Rouen (SIRET 804 466 738 00031)";
const publisherVat =
	import.meta.env.VITE_LEGAL_VAT || "FR68 804 466 738";
const publicationDirector =
	import.meta.env.VITE_LEGAL_PUBLICATION_DIRECTOR ||
	"M. Pierre-Alain Sengier, président";
const hostName =
	import.meta.env.VITE_LEGAL_HOST_NAME || "SmartWork (auto-hébergement)";
const hostAddress =
	import.meta.env.VITE_LEGAL_HOST_ADDRESS ||
	"105 bis Le 105, allée François Mitterrand, 76100 Rouen";
const hostPhone =
	import.meta.env.VITE_LEGAL_HOST_PHONE || "+33 2 78 77 67 92";
const lastUpdated = "2 novembre 2026";

const legalNoticePage = {
	path: "/mentions-legales",
	title: "Mentions légales",
	eyebrow: "Informations légales",
	intro:
		"Cette page regroupe les informations relatives à l’édition, à l’hébergement et à l’utilisation du site SmartWork.",
	updated: lastUpdated,
	metaTitle: "Mentions légales - SmartWork",
	metaDescription:
		"Mentions légales du site SmartWork : éditeur, hébergeur, propriété intellectuelle, responsabilité et contact.",
	sections: [
		{
			title: "Éditeur du site",
			paragraphs: [`Le site ${siteUrl} est édité par ${publisherName}.`],
			items: [
				`Forme juridique : ${publisherStatus}`,
				`Siège social : ${publisherAddress}`,
				`Immatriculation : ${publisherRegistration}`,
				`TVA intracommunautaire : ${publisherVat}`,
				`Email : ${contactEmail}`,
				`Téléphone : ${contactPhone}`,
			],
		},
		{
			title: "Réalisation",
			paragraphs: ["Le site a été réalisé par Gribouillenet Design."],
			items: [
				"Adresse : 2 route de Bosnormand, 27370 Le Thuit de l’Oison",
				{
					label: "Site web",
					value: "https://gribouillenet.fr",
					href: "https://gribouillenet.fr",
				},
			],
		},
		{
			title: "Directeur de la publication",
			paragraphs: [
				`Le directeur de la publication est : ${publicationDirector}.`,
			],
		},
		{
			title: "Hébergement",
			paragraphs: [
				"Le site est hébergé par le prestataire indiqué ci-dessous.",
			],
			items: [
				`Hébergeur : ${hostName}`,
				`Adresse : ${hostAddress}`,
				`Téléphone : ${hostPhone}`,
			],
		},
		{
			title: "Propriété intellectuelle",
			paragraphs: [
				"Les contenus présents sur le site, notamment les textes, visuels, interfaces, éléments graphiques, logos et marques, sont protégés par le droit de la propriété intellectuelle.",
				"Toute reproduction, représentation, modification, adaptation ou exploitation, totale ou partielle, sans autorisation préalable écrite, est interdite.",
			],
		},
		{
			title: "Responsabilité",
			paragraphs: [
				"SmartWork s’efforce de fournir des informations exactes et à jour. Des erreurs ou omissions peuvent toutefois survenir.",
				"L’utilisateur reste responsable de l’usage qu’il fait des informations disponibles sur le site et de la compatibilité de ses équipements avec le service.",
			],
		},
		{
			title: "Données personnelles et cookies",
			paragraphs: [
				"Le traitement des données personnelles et l’utilisation éventuelle de cookies sont détaillés dans les pages dédiées du site.",
			],
			items: [
				"Politique de confidentialité des données",
				"Politique des cookies",
			],
		},
		{
			title: "Contact",
			paragraphs: [
				`Pour toute question relative au site ou à ses contenus, vous pouvez écrire à ${contactEmail}.`,
			],
		},
	],
};

const cookiesPage = {
	path: "/politique-cookies",
	title: "Politique des cookies",
	eyebrow: "Gestion des traceurs",
	intro:
		"Cette politique explique comment SmartWork utilise les cookies et technologies similaires sur son site.",
	updated: lastUpdated,
	metaTitle: "Politique des cookies - SmartWork",
	metaDescription:
		"Politique des cookies du site SmartWork : types de traceurs, finalités, durée de conservation et gestion des préférences.",
	sections: [
		{
			title: "Qu’est-ce qu’un cookie ?",
			paragraphs: [
				"Un cookie est un petit fichier enregistré sur votre terminal lors de la consultation d’un site. Il peut permettre le fonctionnement technique du site, la mesure d’audience ou la personnalisation de l’expérience.",
			],
		},
		{
			title: "Cookies utilisés",
			paragraphs: [
				"À la date de mise à jour de cette page, le site SmartWork est conçu sans cookie publicitaire ni dispositif de suivi commercial.",
				"Des cookies ou stockages strictement nécessaires peuvent être utilisés lorsque certaines fonctionnalités techniques l’exigent, par exemple pour sécuriser un formulaire ou conserver un choix de consentement.",
			],
			items: [
				"Cookies strictement nécessaires : fonctionnement, sécurité et accessibilité du site.",
				"Mesure d’audience : uniquement si un outil compatible avec le consentement est activé.",
				"Services tiers : certaines ressources externes, comme des polices ou icônes, peuvent générer des requêtes techniques auprès de leurs fournisseurs.",
			],
		},
		{
			title: "Durée de conservation",
			paragraphs: [
				"La durée de conservation dépend de la finalité du cookie. Les cookies strictement nécessaires sont conservés pour la durée indispensable au fonctionnement du service.",
				"Lorsqu’un consentement est requis, il est conservé pour une durée maximale de 13 mois, sauf retrait ou modification de votre choix.",
			],
		},
		{
			title: "Gestion de vos choix",
			paragraphs: [
				"Vous pouvez configurer votre navigateur pour accepter, refuser ou supprimer les cookies. Le refus des cookies strictement nécessaires peut dégrader le fonctionnement du site.",
				"Si un outil de gestion du consentement est ajouté au site, il permettra de modifier vos préférences directement depuis l’interface.",
			],
		},
		{
			title: "Contact",
			paragraphs: [
				`Pour toute question sur les cookies, vous pouvez écrire à ${contactEmail}.`,
			],
		},
	],
};

const privacyPage = {
	path: "/politique-confidentialite-donnees",
	title: "Politique de confidentialité des données",
	eyebrow: "Données personnelles",
	intro:
		"Cette politique décrit les traitements de données personnelles réalisés dans le cadre du site SmartWork.",
	updated: lastUpdated,
	metaTitle: "Politique de confidentialité des données - SmartWork",
	metaDescription:
		"Politique de confidentialité SmartWork : données collectées, finalités, base légale, conservation, destinataires et droits RGPD.",
	sections: [
		{
			title: "Responsable du traitement",
			paragraphs: [
				`Le responsable du traitement est ${publisherName}, joignable à ${contactEmail}.`,
			],
			items: [
				`Adresse : ${publisherAddress}`,
				`Immatriculation : ${publisherRegistration}`,
			],
		},
		{
			title: "Données collectées",
			paragraphs: [
				"Les données collectées dépendent de votre usage du site, notamment lorsque vous remplissez le formulaire de contact.",
			],
			items: [
				"Identité : nom et, le cas échéant, entreprise.",
				"Coordonnées : adresse email et numéro de téléphone.",
				"Contenu du message : informations transmises volontairement dans le formulaire.",
				"Données techniques : informations nécessaires à la sécurité, au diagnostic et au bon fonctionnement du site.",
				"Champ anti-spam : champ technique non destiné à être rempli par les utilisateurs.",
			],
		},
		{
			title: "Finalités et bases légales",
			paragraphs: [
				"Les données sont traitées pour répondre aux demandes reçues, préparer un échange commercial ou technique, sécuriser le site et respecter les obligations applicables.",
			],
			items: [
				"Réponse aux demandes de contact : intérêt légitime ou mesures précontractuelles.",
				"Gestion de la relation commerciale : intérêt légitime ou exécution contractuelle.",
				"Sécurité du site : intérêt légitime.",
				"Respect d’obligations légales : obligation légale.",
			],
		},
		{
			title: "Durées de conservation",
			paragraphs: [
				"Les données sont conservées pour une durée proportionnée à la finalité poursuivie.",
			],
			items: [
				"Demandes de contact : jusqu’à 3 ans après le dernier échange.",
				"Données liées à un contrat : pendant la durée de la relation contractuelle puis selon les délais légaux applicables.",
				"Journaux techniques : durée limitée aux besoins de sécurité et de diagnostic.",
			],
		},
		{
			title: "Destinataires",
			paragraphs: [
				"Les données sont destinées aux équipes habilitées de SmartWork et, si nécessaire, à ses prestataires techniques agissant pour le compte de SmartWork.",
				"SmartWork ne vend pas les données personnelles collectées via le site.",
			],
		},
		{
			title: "Transferts hors Union européenne",
			paragraphs: [
				"SmartWork privilégie des traitements et prestataires situés dans l’Union européenne. Si un transfert hors Union européenne devait être nécessaire, il serait encadré par des garanties appropriées.",
			],
		},
		{
			title: "Vos droits",
			paragraphs: [
				"Conformément au RGPD et à la loi Informatique et Libertés, vous disposez de droits sur vos données personnelles.",
			],
			items: [
				"Droit d’accès, de rectification et d’effacement.",
				"Droit à la limitation et à l’opposition.",
				"Droit à la portabilité lorsque ce droit est applicable.",
				"Droit de retirer votre consentement lorsque le traitement repose sur celui-ci.",
				"Droit d’introduire une réclamation auprès de la CNIL.",
			],
		},
		{
			title: "Exercer vos droits",
			paragraphs: [
				`Vous pouvez exercer vos droits en écrivant à ${contactEmail}. Une pièce justificative pourra être demandée si nécessaire pour confirmer votre identité.`,
			],
		},
	],
};

const termsPage = {
	path: "/conditions-generales-utilisation",
	title: "Conditions Générales d’Utilisation du site",
	eyebrow: "CGU",
	intro:
		"Les présentes Conditions Générales d’Utilisation encadrent l’accès et l’utilisation du site SmartWork.",
	updated: lastUpdated,
	metaTitle: "Conditions Générales d’Utilisation - SmartWork",
	metaDescription:
		"Conditions Générales d’Utilisation du site SmartWork : accès, usage, responsabilités, propriété intellectuelle et droit applicable.",
	sections: [
		{
			title: "Objet",
			paragraphs: [
				"Les présentes CGU ont pour objet de définir les conditions dans lesquelles les utilisateurs accèdent au site SmartWork et utilisent les contenus, formulaires et informations qui y sont proposés.",
			],
		},
		{
			title: "Acceptation des CGU",
			paragraphs: [
				"La consultation du site implique l’acceptation des présentes CGU. Si vous n’acceptez pas ces conditions, vous devez cesser d’utiliser le site.",
			],
		},
		{
			title: "Accès au site",
			paragraphs: [
				"SmartWork met tout en œuvre pour assurer l’accessibilité du site. L’accès peut toutefois être suspendu temporairement pour maintenance, mise à jour, incident technique ou cas de force majeure.",
			],
		},
		{
			title: "Utilisation du site",
			paragraphs: [
				"L’utilisateur s’engage à utiliser le site conformément aux lois et règlements applicables, sans porter atteinte à son fonctionnement, à sa sécurité ou aux droits de tiers.",
			],
			items: [
				"Ne pas détourner les formulaires de leur finalité.",
				"Ne pas transmettre de contenu illicite, abusif ou portant atteinte aux droits de tiers.",
				"Ne pas tenter d’accéder frauduleusement à des systèmes, données ou services non autorisés.",
			],
		},
		{
			title: "Informations publiées",
			paragraphs: [
				"Les informations publiées sur le site sont fournies à titre informatif. Elles ne constituent pas une offre contractuelle ferme sauf mention expresse contraire.",
				"SmartWork peut modifier, compléter ou supprimer tout contenu du site à tout moment.",
			],
		},
		{
			title: "Propriété intellectuelle",
			paragraphs: [
				"Les contenus et éléments graphiques du site sont protégés. Toute reproduction ou exploitation non autorisée est interdite. Ils ont tous été créés par SmartWork ou ses partenaires. Ils ont été générés par IA et sont la propriété exclusive de SmartWork ou de leurs auteurs respectifs.",
			],
		},
		{
			title: "Liens externes",
			paragraphs: [
				"Le site peut contenir des liens vers des sites tiers. SmartWork n’exerce aucun contrôle sur ces sites et ne peut être tenue responsable de leurs contenus ou pratiques.",
			],
		},
		{
			title: "Données personnelles",
			paragraphs: [
				"Les traitements de données personnelles réalisés via le site sont décrits dans la Politique de confidentialité des données.",
			],
		},
		{
			title: "Droit applicable",
			paragraphs: [
				"Les présentes CGU sont soumises au droit français. En cas de litige, les parties rechercheront une solution amiable avant toute action judiciaire.",
			],
		},
		{
			title: "Contact",
			paragraphs: [
				`Pour toute question relative aux CGU, vous pouvez écrire à ${contactEmail}.`,
			],
		},
	],
};

export const legalPageLinks = [
	{
		path: legalNoticePage.path,
		label: "Mentions Légales",
	},
	{
		path: cookiesPage.path,
		label: "Politique des cookies",
	},
	{
		path: privacyPage.path,
		label: "Politique de confidentialité",
	},
	{
		path: termsPage.path,
		label: "CGU",
	},
];

export const legalPages = {
	[legalNoticePage.path]: legalNoticePage,
	[cookiesPage.path]: cookiesPage,
	[privacyPage.path]: privacyPage,
	"/politique-confidentialite": privacyPage,
	[termsPage.path]: termsPage,
	"/cgu": termsPage,
};
